import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const table: NodeRenderer = (node, children) => (
  <div className="block overflow-x-auto">
    <table className="w-full">
      <tbody>{children}</tbody>
    </table>
  </div>
)
